import styles from './utils.module.scss';

// These image ratios have been lifted from the design system
// https://github.com/redbubble/design/blob/5c2819216a90638e4bfa8333b37ba50d96437302/react/Image/styles.scss
// https://github.com/redbubble/design/blob/b3001cbdf4b62db93dbbec5bc2c47abd00ad9425/react/constants.js
// the cover and contain constants have not been included as they are not currently used

export const imageRatio = {
  RATIO_SQUARE: 'square',
  RATIO_PORTRAIT: 'portrait',
  RATIO_LANDSCAPE: 'landscape',
} as const;

type ImageRatio = typeof imageRatio;

// This helper gets the correct image class for common IHS image ratios
// Use of this helper is optional and one can simply create a css class with
// the correct padding to ensure no CLS.
// the formula to get this padding is, height / width * 100 = padding-bottom value
// for example. 750w 1000h image -> 1000 / 750 * 100 = padding-bottom: 133%  (rounded from 133.3333)
export const getImageRatioClass = (ratio: ImageRatio[keyof ImageRatio]) =>
  styles[ratio];
